import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, ShieldOff } from "lucide-react";
import AdminLayout from "../../components/AdminLayout";
import { api } from "../../lib/api";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const load = () => api.get("/admin/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const del = async (u) => {
    if (!window.confirm(`Delete ${u.role === "admin" ? "ADMIN" : "user"} ${u.email}? This cannot be undone.`)) return;
    try {
      await api.delete(`/admin/users/${u.id}`);
      toast.success("USER DELETED");
      load();
    } catch (err) {
      toast.error("FAILED", { description: err?.response?.data?.detail || "" });
    }
  };

  const clearDemo = async () => {
    if (!window.confirm("Delete ALL non-admin users (purge demo accounts)? This cannot be undone.")) return;
    try {
      const r = await api.delete("/admin/users");
      toast.success(`CLEARED ${r.data.deleted_users} USERS`);
      load();
    } catch (err) {
      toast.error("FAILED", { description: err?.response?.data?.detail || "" });
    }
  };

  const nonAdminCount = users.filter((u) => u.role !== "admin").length;

  return (
    <AdminLayout title="Members">
      <div className="flex justify-between items-center mb-4">
        <p className="label-mono text-[#71717A]">{users.length} TOTAL // {nonAdminCount} NON-ADMIN</p>
        {nonAdminCount > 0 && (
          <button onClick={clearDemo} className="label-mono px-3 py-2 border border-red-900 text-red-500 hover:bg-red-950 flex items-center gap-2" data-testid="clear-demo-users-btn">
            <ShieldOff size={14} /> CLEAR ALL DEMO USERS
          </button>
        )}
      </div>
      <div className="bg-[#0A0A0A] border border-[#27272A] overflow-x-auto">
        <table className="w-full text-sm" data-testid="admin-users-table">
          <thead className="border-b border-[#27272A]">
            <tr className="label-mono text-[#71717A]">
              <th className="text-left p-4">EMAIL</th>
              <th className="text-left p-4">NAME</th>
              <th className="text-left p-4">MOBILE</th>
              <th className="text-left p-4">ROLE</th>
              <th className="text-left p-4">JOINED</th>
              <th className="text-right p-4">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => {
              const phone = u.phone_full || (u.phone ? `${u.country_code || ""}${u.phone}` : "");
              return (
                <tr key={u.id} className="border-b border-[#18181B]" data-testid={`user-row-${u.id}`}>
                  <td className="p-4 font-mono-cult">{u.email}</td>
                  <td className="p-4 font-display font-bold">{u.name}</td>
                  <td className="p-4 font-mono-cult text-[#A1A1AA]" data-testid={`user-phone-${u.id}`}>
                    {phone ? (
                      <a href={`tel:${phone}`} className="hover:text-[#CFF048]">{phone}</a>
                    ) : (
                      <span className="text-[#52525B]">—</span>
                    )}
                  </td>
                  <td className="p-4 label-mono"><span className={u.role === "admin" ? "text-[#CFF048]" : ""}>{u.role.toUpperCase()}</span></td>
                  <td className="p-4 font-mono-cult text-[#71717A]">{new Date(u.created_at).toLocaleDateString()}</td>
                  <td className="p-4 text-right">
                    {u.role !== "admin" ? (
                      <button onClick={() => del(u)} className="text-[#71717A] hover:text-red-500" data-testid={`delete-user-${u.id}`}>
                        <Trash2 size={16} />
                      </button>
                    ) : (
                      /* Allow deleting other admins (e.g. old admin@cultlyf.com) but not self */
                      <button onClick={() => del(u)} className="text-[#27272A] hover:text-red-500 transition-colors" title="Delete admin" data-testid={`delete-admin-${u.id}`}>
                        <Trash2 size={16} />
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
